import axios from "axios";
import { authHeader } from "@/helpers/authHeader.js";
import { KUrls } from "@/helpers/constants";

export const validationService = {
  validateDocument,
  validateVolume,
};

const validationEndpoint = KUrls.VALIDATION_ENDPOINT || "/validate";

async function validateDocument(companySchema, documentId, isHisory) {
  const authorization = authHeader();
  const response = await axios.post(
    `${KUrls.BASE_REST_URL}${validationEndpoint}/${companySchema}/documents`,
    {
      documentId,
      isHisory,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: authorization,
      },
    }
  );
  const data = { ...response.data };

  return data;
}

async function validateVolume(companySchema, volumeId) {
  const authorization = authHeader();
  const response = await axios.post(
    `${KUrls.BASE_REST_URL}${validationEndpoint}/${companySchema}/volumes`,
    {
      volumeId,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: authorization,
      },
    }
  );
  const data = { ...response.data };
  return data;
}
